// extracted by mini-css-extract-plugin
module.exports = {"Button":"HotelInformation-module--Button--2q68V"};